import React, {Component} from 'react';
import PropTypes from 'prop-types';

const $ = window.jQuery;

class OpenFileDialog extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        multiple: PropTypes.bool,
        accept: PropTypes.string
    };
    static defaultProps = {
        multiple: false,
        accept: ""
    };
    state = {};

    componentDidMount() {
        const {onChange} = this.props;

        this.$el = $(this.el);
        this.$el.on('change', event => {
            const {files} =  event.dataTransfer || event.target;

            onChange([...files], event);
        });
    }

    render() {
        const {multiple, accept} = this.props;
        return (
            <input ref={el => this.el = el}
                   type="file" style={{display: 'none'}} multiple={multiple} accept={accept}/>
        );
    }

    open() {
        this.$el.val('').click();
    }
}

export default OpenFileDialog;


// WEBPACK FOOTER //
// ./src/utils/components/OpenFileDialog.js